import React, { useState, useEffect } from 'react';
import LayoutProvider from '../../../providers/LayoutProvider';
import { deleteUser, getUserbyId, getUsers, getUsersbySearch, statusChange, updateUser } from '../../../components/Axios/Axios';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import AdminPagesProvider from '../../../providers/AdminPagesProvider';
import { FaEllipsisH, FaSearch } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';
import useCustomToast from '../../../hooks/useCustomToast';
import { Toaster } from 'react-hot-toast';
import ReactPaginate from 'react-paginate';
import SpinnerLoader from '../../../components/SpinnerLoader';
import { API_STATUS } from '../../../constants';
import Animations from '../../../components/TableSkeleton';

export default function Users() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const customToast = useCustomToast();
  const [active, setActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages,setTotalPages]=useState(0)
  const [loading,setLoading]=useState(false)
  const [userName,setUserName]=useState("")


  const handleDelete = async (id: any) => {
    try {
      await deleteUser(id);
      console.log(id)
      fetchData(); 
      customToast("User deleted successfully", "success");
    } catch (error) {
      console.error('Error deleting user:', error);
      customToast("Error deleting user", "error");
    }
  };

  const handleSearch = async (userName: any) => {
    try {
      setLoading(false)
      const response = await getUsersbySearch(userName);
      console.log("ccc",response)
      setRows(response.data);
      const page = response.paginator;
      setItemsPerPage(page.perPage)
      setTotalPages(page.totalPages)
      setLoading(true)
    } catch (error) {
      console.error('User not found:', error);
      setLoading(true)
    }
  };


// Activate and Deactivate user
  const handleActive = async (id: any) => {
   
    try {
      await statusChange(id)

      fetchData();
    }
    catch (error) {
      console.error("Can't Change active status", error);
    }

  };

//View User
  const handleView= (id:any)=>{
    navigate(`/admin/edit-user/${id}`);
  }

  const columns = [
    {
      name: 'Username',
      cell: (row: any) => (
        <button onClick={()=>handleView(row._id)}  style={{border:"none",background:"none"}}>
          {row?.username}
        </button>
      ),
      sortable: true,
      grow: 3,
      wrap: true,
    },
    {
      name: 'Email',
      selector: (row: any) => row?.email,
      sortable: true,
      grow: 3,
      wrap: true,
    },
    {
      name: 'Status',
      cell: (row: any) => (
        <button onClick={e=>handleActive(row?._id)} style={{border:"none"}}className={`badge p-2 ${row.isActive ? 'bg-success' : 'bg-danger'}`}>
          {row.isActive ? 'Active' : 'Not Active'}
        </button>
      ),
      grow: 2,
      wrap: true,
    },
    {
      cell: (row: any) => (
        <Dropdown >
          <Dropdown.Toggle  id="dropdown-basic" style={{ background: "none", color: "#5b5b5b", border: "none" }}>
            <FaEllipsisH />
          </Dropdown.Toggle>
          <Dropdown.Menu className={rows.length <=2 ? 'custom' : 'simple'}> {/* Add the class here */}
            <Dropdown.Item type='button' onClick={() => handleDelete(row._id)}>Delete</Dropdown.Item>
            <Dropdown.Item href="#/action-2" onClick={() => handleView(row._id)}>Edit</Dropdown.Item>
            {/* <Dropdown.Item href="#/action-3">{row.isActive ? "Deactivate" : "Activate"}</Dropdown.Item> */}
            <Dropdown.Item onClick={() => navigate(`/admin/users/user-stats/${row._id}`)}>View Stats</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(false)
      const response = await getUsers(currentPage);
      const users = response.data || [];
      const page = response.paginator;
      setItemsPerPage(page.perPage)
      setTotalPages(page.totalPages)
      setRows(users);
      setLoading(true)
    } catch (error) {
      setLoading(true)
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]); // Fetch data on initial render

  // useEffect(() => {
  //   handleSearch(userName);
  // }, [userName]);

  const handleClick = () => {
    navigate('/admin/invite-users');
  };

  const handlePageChange = ({ selected }: { selected: number }) => {
    setCurrentPage(selected + 1); // Adjust currentPage value to start from 1
  };


  return (
    <AdminPagesProvider>
      <LayoutProvider>
      {loading === false && <SpinnerLoader />}
        <h6 className="dashboard_subheading">Dashboard {'>'} Users</h6>
        <section
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className="dashboard_heading">Users</h4>
          <div>
            <button className="button" onClick={handleClick}>
              Invite users
            </button>
          </div>
        </section>
      <div className='search-container'>
      <input
        type="search"
        placeholder="Search by Username"
        className="input"
        name="username"
        value={userName}
        onChange={e => setUserName(e.target.value)}
      />
      <FaSearch className="search-icon" onClick={()=>handleSearch(userName)} />
    </div>
        <div style={{ width: '100%', marginTop: '2%' }}>
          <Toaster/>
        <DataTable
            columns={columns}
            data={rows || []}
            selectableRows
            customStyles={{
              rows: {
                style: {
                  minHeight: '60px',
                  '&:nth-child(odd)': {
                    background: '#EFF6FF',
                  },
                },
              },
              headCells: {
                style: {
                  fontSize: '14px',
                  fontWeight: 'bold',
                },
              },
              cells: {
                style: {
                  fontSize: '14px',
                },
              },
            }}
          />
        <div className="pagination-container-one">
        <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
        </div>
      </LayoutProvider>
    </AdminPagesProvider>
  );
}
